module.exports = __webpack_public_path__ + "img/leval-1.9ae09d36.png";